export enum FinishReasonEnum {
    CLOSED_BY_USER = 'closeByUser',
    SUCCESS = 'success',
    FAILED = 'fail'
}
